import * as ApiClient from '@/libs/ApiClient';
import type { AxiosResponse } from 'axios';
import type { ClientUploadResult } from '@/models/ClientUploadResult';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * 客戶上傳身分證正面文件請求參數
 */
export interface IClientUploadIdFrontFileParams {
    /** 上傳檔案內容 (Base64) */
    fileBase64Content: string;
    /** 關聯的上傳項目ID (第2層項目) */
    itemID: number;
    /** 檔案Mime Type */
    mimeType: string;
    /** 已上傳檔案fileHash */
    fileHash: string;
}

/**
 * 客戶上傳身分證正面文件回應 (API_GeneralResp 格式)
 */
export interface IClientUploadIdFrontFileResponse {
    /** 回應狀態 */
    status: boolean;
    /** 錯誤代碼 */
    code: number;
    /** 例外訊息 */
    exception: string | null;
    /** 訊息 */
    message: string | null;
    /** 上傳成功後的結果 */
    result: ClientUploadResult | null;
}

/**
 * Client - 客戶上傳身分證正面文件 API (含OCR換補領資訊)
 *
 * @description 客戶上傳身分證正面文件，後端會執行 OCR 辨識換補領資訊
 * @param params 上傳檔案請求參數
 * @returns Promise<IClientUploadIdFrontFileResponse>
 */
export async function ClientUploadIdFrontFile(params: IClientUploadIdFrontFileParams): Promise<IClientUploadIdFrontFileResponse> {
    const url = RouteUrlList.API_ClientUploadIdFrontFile.path;
    const config = {
        params: {
            showOverlay: ApiClient.paramTypeEnum.false,
            getServiceAlert: ApiClient.paramTypeEnum.true
        }
    };

    return await ApiClient.post(url, params, config).then((res: AxiosResponse<IClientUploadIdFrontFileResponse>) => {
        return res.data;
    });
}

export default ClientUploadIdFrontFile;
